import React from "react";
import { BodyContainer } from "../../components";
import { Col } from "antd";
import { databaseBg, solarone, solartwo, solarthree, solarfour, solarfive } from "../../assets";
import Card from "../../components/cards/Card";

function SolarServices(props) {
  return (
    <>
     <BodyContainer bgImage={databaseBg}>
        <h1>
          <span>Solar </span> Services
        </h1>
      </BodyContainer>
      <div id="one" className="freebcol">
    <Card
        className="fitImage1"
 
        gutter={[34, 34]}
        Image={
          <Col xs={24} sm={24} md={12} lg={10}>
            <img src={solarone} alt="about1" />
          </Col>
        }
        Body={
          <Col xs={24} lg={12}>
            
            <h1>Solar Permit Designs
</h1>
            <ul>
              <li>
              We are one of the leading company in designing solar permit plans. Our permit package includes a site plan of the property, a detailed schematic of the proposed solar panel layout, single-line & three-line diagrams for electrical layout & calculations, warning labels, and tech sheets.


              </li>
              <li>We provide both Residential & Commercial system permit designs within 6 hours turn around time. Our teams are well aware of National Electric Codes (NEC) and other applicable codes for various AHJs and Home Owner Association (HOA) requirements. We are pretty swift in adapting codes changes and any custom requirements from customer, installer and/or EPCs.</li>
            </ul>
          </Col>
        }
      /></div>
<div id="two" className="freebcol">
<Card
        className="fitImage1"
        gutter={[34, 34]}
        Image={
          <Col xs={24} sm={24} md={12} lg={12}>
            <img src={solartwo} alt="about1" />
          </Col>
        } reverse
        Body={
          <Col xs={24} lg={12}>
            
            <h1>Solar Sales Proposals
</h1>
            <ul>
              <li>
              Our solar proposals let you educate your customers about solar and quickly configure your solar estimate. We provide both Residential & Commercial system sales proposals within 2 hours turn around time. We highlight production estimate, pricing, return on investment, financing, incentives, Installation overview, Hardware and specification of the system etc. in our detailed sales proposals.


              </li>
            </ul>
          </Col>
        }
      /></div>
<div id="three" className="freebcol">

<Card
        className="fitImage1"
        gutter={[34, 34]}
        Image={
          <Col xs={24} sm={24} md={12} lg={10}>
            <img src={solarthree} alt="about1" />
          </Col>
        }
        Body={
          <Col xs={24} lg={12}>
            
            <h1>Solar Preliminary Designs

</h1>
            <ul>
              <li>
              Our preliminary design and production analysis reports will help customers to calculate the Annual Production and Shading, and ensure they will be receiving optimal power production. We provide both Residential & Commercial system preliminary designs within 2 hours turn around time. We use AuroraSolar, Helioscope & Scanifly integrated, web based application to simulate the physical layout, power production, offsets and design of your recommended system based on your current information and goals.



              </li>
               
            </ul>
          </Col>
        }
      /></div>
<div id="four" className="freebcol">

<Card
        className="fitImage1"
        gutter={[34, 34]}
        Image={
          <Col xs={24} sm={24} md={12} lg={12}>
            <img src={solarfour} alt="about1" />
          </Col>
        } reverse
        Body={
          <Col xs={24} lg={12}>
            
            <h1>Engineering Stamps

</h1>
            <ul>
              <li>
              Our highly experienced professional engineers can help you with permitting, building department review and Professional Engineer Certification as per NEC, NESC, NFPA 70E, IEEE, ANSI and NEMA standards. Our Professional Engineer can review, Sign and Stamp Engineering Plan Sets & provide Reports & Calculations Permit Compliance Letters & Calculations, Power System Studies. We offer in-house Structural & Electrical engineering services for both Residential and Commercial projects within 18-24 Hours.




              </li>
            </ul>
          </Col>
        }
      />
</div>

<div id="five" className="freebcol">
<Card
        className="fitImage1"
        gutter={[34, 34]}
        Image={
          <Col xs={24} sm={24} md={12} lg={10}>
            <img src={solarfive} alt="about1" />
          </Col>
        }
        Body={
          <Col xs={24} lg={12}>
            
            <h1>As-Built Drawings

</h1>
            <ul>
              <li>
              Our As Built prelim & permit plan shows the actual installed solar system based on the post installation pictures. We provide As Built Drawings, final prelim & permit designs within 6 hours turn around time. Also, we get them approved by our in house engineering services team.





              </li>
               
            </ul>
          </Col>
        }
      />
      </div>







 
    </>
  );
}

export default SolarServices;
